// extracted by mini-css-extract-plugin
export default {"modalBorder":"MediaGallery_modalBorder__rc2kR","border":"MediaGallery_border__hx0Pb","carouselImage":"MediaGallery_carouselImage__ifA3j"};